import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries'
import { GlobalContext } from '../../../App';
import { updateOrAddItem, useAddData, useGetDataByName, useUpdateData } from '../../dataLocal/indexedDBHooks';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const usePaymentQueries = () => {
  const { setDataPayments, userId, db } = useContext(GlobalContext)
  const { AllDataEntities, addOrUpdateDataEntity2 } = useCURD_Queries()

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataPayments = async () => {
    try {
      let query = `api/payments/getPayments`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataPayments'

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataPayments(data?.resData || [])
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 12, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 12, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }

    } catch (error) {
      console.error("שגיאה בטעינת נתונים: ", error);
    }
  }

  const addOrUpdateDataPayment = async (data, unicId) => {
    console.log('step1:',data, unicId);
    
    let create = `api/payments/addPayment`
    let update = `api/payments/updatePayment`
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${(data?.id) ? update : create}`;
    

    console.log('step2:',url, data?.unicId );
    let ip = ''
    // דוגמה לשימוש בפונקציה
    await getUserIP().then(myIp => {
      ip = myIp
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'payments',
      actionType: (data?.id) ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data,
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      }
    }

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url);
      if (res) {
        await updateOrAddItem(db, 'myStore', data, 'dataPayments', 12 );
        console.log('התוצאה הצליחה...')
        return res
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
    }
  }

 

  return {
    AllDataPayments,
    addOrUpdateDataPayment,
  }
}

export default usePaymentQueries
